import { IconProps } from "./dto";

export function DangerIcon(icon: IconProps) {
    return (
        <svg width={icon.size} height={icon.size} viewBox="0 0 22 22" fill="none">
            <path d="M11 7V11M11 15H11.01M6.86 1H15.14L21 6.86V15.14L15.14 21H6.86L1 15.14V6.86L6.86 1Z" stroke={icon.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
